import { ConnectionType } from '@sembo-private/maps';
import type { Serializer } from '@sembo-private/utils';

import {
  isBookableTransport,
  DEFAULT_TRANSPORT_TYPE,
} from '../../helpers/transports';

export const ConnectionTypeSerializer: Serializer<ConnectionType> = {
  serialize: function (connectionType: ConnectionType): string {
    return connectionType.toString();
  },
  deserialize: function (value: string): ConnectionType {
    const connectionType = ConnectionType[parseInt(value)];

    if (!connectionType) {
      return DEFAULT_TRANSPORT_TYPE;
    }

    const transportToDeserialize = ConnectionType[connectionType];

    return isBookableTransport(transportToDeserialize)
      ? DEFAULT_TRANSPORT_TYPE
      : transportToDeserialize;
  },
};
